module.exports = __webpack_public_path__ + "static/media/2d-controls-icon.4d7ac4ee.svg";